import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { LoggerModule } from 'ngx-logger';
import { initFaroFromConfig, setFaroSessionAttributes } from 'tofe-core';
import { TofeLanguageModule } from 'tofe-language';
import { TofeSessionModule } from 'tofe-session';
import { ApiModule, Configuration, ConfigurationParameters } from 'top-api-sdk-angular';

import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { APP_CONFIG, AppConfig, loadAppConfig } from './app/core/services/app-config.service';
import { environment } from './environments/environment';

function createProviders(config: AppConfig) {
  function apiConfigFactory(): Configuration {
    const params: ConfigurationParameters = {
      basePath: config.apiBaseUrl,
    };
    return new Configuration(params);
  }

  return [
    { provide: APP_CONFIG, useValue: config },
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
    importProvidersFrom(
      TofeSessionModule.forRoot({
        apiBaseUrl: config.apiBaseUrl,
        faroHttpCapture: config.faro?.httpCapture,
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(LoggerModule.forRoot(environment.logs.logger)),
    importProvidersFrom(ApiModule.forRoot(apiConfigFactory)),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    importProvidersFrom(
      TofeLanguageModule.forRoot({
        isViewTokenEnabled: config.environment !== 'prod',
      }),
    ),
  ];
}

loadAppConfig().then((config) => {
  // Initialize observability in the background. Faro init lazy-loads sizeable
  // SDK chunks; awaiting it here would delay (or, on a slow network, block) the
  // whole app bootstrap. Fire-and-forget so the UI renders immediately.
  initFaroFromConfig(config.faro, { environment: config.environment })
    .then(() => {
      setFaroSessionAttributes({
        tabInstanceId: crypto.randomUUID(),
      });
    })
    .catch(
      /* istanbul ignore next */
      (err) => console.error('[Faro] init failed:', err),
    );

  bootstrapApplication(AppComponent, {
    providers: [provideZoneChangeDetection(), ...createProviders(config)],
  }).catch(
    /* istanbul ignore next */
    (err) => console.error(err),
  );
});
